import { useQuery } from '@tanstack/react-query';

import type { EventListFilters } from '../filters';
import type { EventListViewData } from './EventApi';
import { useEventApi } from './EventApiProvider';

interface UseEventListQueryResult {
  data?: EventListViewData;
  isLoading: boolean;
}

function useEventListQuery(params: EventListFilters): UseEventListQueryResult {
  const api = useEventApi();

  const { data, isLoading } = useQuery({
    queryKey: ['event-api', 'list', params],
    queryFn: async () => api.getEvents(params),
  });

  return { data, isLoading };
}

export { useEventListQuery };
